import axios from "axios";
import type {ArtistType, FetchArtistsPayload, FetchArtistsResponse, ArtistReviewTypeResponse} from "@songfinch/types";

export const fetchArtist = async (id: string): Promise<ArtistType> => {
    const res = await axios.get(`/artists/${id}`);
    return res.data.data;
};

export const fetchArtistReviews = async (id: string): Promise<ArtistReviewTypeResponse> => {
    const res = await axios.get(`/artists/${id}/reviews`);
    return res.data;
};


export async function fetchArtists(params: FetchArtistsPayload): Promise<FetchArtistsResponse> {
    const res = await axios.get<FetchArtistsResponse>(`/artists`, {params});
    return res.data;
}